// `usePageContext` allows us to access `pageContext` in any Vue component.
// See https://vite-plugin-ssr.com/pageContext-anywhere

import { inject } from 'vue';
import type { PageContext } from 'vite-plugin-ssr/types';
import type { App, InjectionKey, UnwrapNestedRefs } from 'vue';

let key: InjectionKey<PageContext> = Symbol('pageContext');

export const pageContextKey = key;

function usePageContext() {
  const pageContext = inject(key);
  if (!pageContext) throw new Error('setPageContext() not called in parent');

  return pageContext;
}

function setPageContext(app: App, pageContext: UnwrapNestedRefs<PageContext>) {
  app.provide(key, pageContext as PageContext);
}

export function updatePageContextKeyForTest(k: string) {
  key = Symbol(k);
  return key;
}

export { usePageContext };
export { setPageContext };
